module.exports = {
      id: "logo-small-usage",
      viewBox: "0 0 192 28",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#logo-small",
      toString: function () {
        return this.url;
      }
    }